import Eastern61 from '../Eastern/Grand Eastern 6 (1).webp'
import Eastern62 from '../Eastern/Grand Eastern 6 (2).webp'


const Eastern6images =[
Eastern61,Eastern62
]

export default Eastern6images;